export const loginPath = '/'
export const landingPath='/orders'
export const defaultRole = 'MEMBER'
